// VisualUnitContext.tsx
import React, { createContext, useContext } from 'react';
import { VisualUnitStore } from '../../Redux/zustand_VisualUnitStore';
import { useStore } from 'zustand';

const VisualUnitContext = createContext<VisualUnitStore | null>(null);

export const Zustand_VisualUnitProvider: React.FC<{
  store: VisualUnitStore;
  children: React.ReactNode;
}> = ({ store, children }) => {
  return <VisualUnitContext.Provider value={store}>{children}</VisualUnitContext.Provider>;
};

export const useZustandVisualUnitStore = <T,>(
  selector: (state: ReturnType<VisualUnitStore['getState']>) => T
): T => {
  const store = useContext(VisualUnitContext);
  if (!store) throw new Error('VisualUnitProvider is missing');
  return useStore(store, selector);
};

export const useVisualUnitScopedStore = (): VisualUnitStore => {
  const store = useContext(VisualUnitContext);
  if (!store) throw new Error('VisualUnitProvider is missing');
  return store;
};